<ng-template pTemplate="header">
  <span class="text-xl font-bold">{{ question_title }}</span>
</ng-template>

<div class="tbl max-w-full">
  <p-accordion>
    <p-accordionTab header="Filtri">
      <form
        [formGroup]="frmFilter"
        class="p-fluid grid">
        <!-- <div class="col-4">
          <p-autoComplete
            [suggestions]="suggestedWarehouses"
            (completeMethod)="filterWarehouses($event)"
            field="name"
            id="id"
            dataKey="id"
            [emptyMessage]="'Nessun risultato trovato'"
            formControlName="related_warehouse"
            [forceSelection]="true"
            [showClear]="true"
            styleClass="w-full"
            class="flex-grow-1"
            placeholder="Filtra per magazzino..."
            [showClear]="true"></p-autoComplete>
        </div>

        <div class="col-4">
          <p-autoComplete
            [suggestions]="suggestedAgreements"
            (completeMethod)="filterAgreements($event)"
            field="name"
            id="id"
            class="flex-grow-1"
            dataKey="id"
            [emptyMessage]="'Nessun risultato trovato'"
            formControlName="related_agreement"
            [forceSelection]="true"
            [showClear]="true"
            styleClass="w-full"
            placeholder="Filtra per nome commessa..."
            [showClear]="true">
            <ng-template
              let-commessa
              pTemplate="item">
              <div class="flex align-items-center gap-2">
                <div>{{ commessa.name }} ({{ commessa.identifier }})</div>
              </div>
            </ng-template></p-autoComplete
          >
        </div> -->

        <!-- Product Info -->
        <div class="col-3">
          <input
            id="part_number"
            pInputText
            formControlName="part_number"
            placeholder="Filtra per part number..."
            class="w-full" />
        </div>

        <div class="col-3">
          <input
            id="serial_number"
            pInputText
            formControlName="serial_number"
            placeholder="Filtra per serial number..."
            class="w-full" />
        </div>

        <div class="col-3">
          <input
            id="asset_code"
            pInputText
            formControlName="asset_code"
            placeholder="Filtra per codice asset..."
            class="w-full" />
        </div>

        <!-- Notes -->
        <div class="col-3">
          <input
            pInputText
            formControlName="notes"
            placeholder="Filtra per note..."
            class="w-full" />
        </div>

        <!-- State -->
        <div class="col-1">
          <div class="flex align-items-center gap-1 h-full">
            <p-checkbox
              formControlName="active"
              [binary]="true"
              inputId="active_id"></p-checkbox>
            <label for="active_id">Attivo</label>
          </div>
        </div>

        <div class="col-1">
          <div class="flex align-items-center gap-1 h-full">
            <p-checkbox
              formControlName="lost"
              [binary]="true"
              inputId="lost_id"></p-checkbox>
            <label for="lost_id">Perso</label>
          </div>
        </div>

        <div class="col-1">
          <div class="flex align-items-center gap-1 h-full">
            <p-checkbox
              formControlName="faulty"
              [binary]="true"
              inputId="faulty_id"></p-checkbox>
            <label for="faulty_id">Guasto</label>
          </div>
        </div>

        <div class="col-4">
          <p-calendar
            selectionMode="range"
            id="end_of_warranty_date"
            dateFormat="dd/mm/yy"
            formControlName="end_of_warranty_date"
            placeholder="Fine garanzia"></p-calendar>
        </div>

        <div class="col-4">
          <p-calendar
            selectionMode="range"
            id="testing_date"
            dateFormat="dd/mm/yy"
            formControlName="testing_date"
            placeholder="Data collaudo"></p-calendar>
        </div>

        <div class="col-12">
          <p-button
            styleClass="butt w-full"
            icon="pi pi-filter-slash"
            (click)="clear(assetTable)"
            pTooltip="Elimina filtri"
            tooltipPosition="top"></p-button>
        </div>
      </form>
    </p-accordionTab>
  </p-accordion>
  <p-table
    [paginator]="true"
    dataKey="id"
    [value]="availableAssetsManagement"
    #assetTable
    [rows]="25"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="rowsPerPageOptions"
    [lazy]="true"
    (onLazyLoad)="fetchAssetsManagements($event)"
    [totalRecords]="totalRecords"
    [showCurrentPageReport]="true"
    (onRowSelect)="onAssetSelect($event)"
    [selectionMode]="pickerType === 'radio' ? 'single' : 'multiple'"
    currentPageReportTemplate="Risultati {first} - {last} di {totalRecords} totali">
    <ng-template pTemplate="header">
      <tr class="tHead">
        <th></th>
        <th>Codice asset</th>
        <th>Serial number</th>
        <th>Part number prodotto</th>
        <th>Magazzino</th>
        <th>Commessa</th>
        <th>Fine garanzia</th>
        <th>Data collaudo</th>
        <th>Stato</th>
        <th>Note</th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-a>
      <tr
        [pSelectableRow]="a"
        class="trClickable">
        <!-- <td *ngIf="pickerType !== 'radio'">
          <p-tableCheckbox [value]="a"></p-tableCheckbox>
        </td>
        <td *ngIf="pickerType === 'radio'">
          <p-radioButton
            [value]="a.id"
            name="selectedAM"
            [formControl]="selectedAM"></p-radioButton>
        </td> -->
        <!-- MULTIPLE -->
        <td *ngIf="pickerType !== 'radio'">
          <p-tableCheckbox [value]="a"></p-tableCheckbox>
        </td>

        <!-- SINGLE -->
        <td *ngIf="pickerType === 'radio'">
          <p-tableRadioButton [value]="a"></p-tableRadioButton>
        </td>
        <td>{{ a.asset_code || '-' }}</td>
        <td>{{ a.serial_number }}</td>
        <td>
          {{ a.related_product?.part_number || '-' }}
        </td>
        <td>{{ a.related_warehouse?.name }}</td>
        <td>
          <span class="mb-0"> {{ a.related_agreement.name }} </span><br />
          <small class="grey-text">
            {{ a.related_agreement.identifier }}
          </small>
        </td>

        <td>
          {{ (a.end_of_warranty_date | date: 'dd/MM/yyyy') || '-' }}
        </td>
        <td>
          {{ (a.testing_date | date: 'dd/MM/yyyy') || '-' }}
        </td>

        <td>
          <p-chip [label]="a.active === true ? 'Attivo' : 'Disattivo'"></p-chip>
          <p-chip
            *ngIf="a.lost"
            label="Perso"></p-chip>
          <p-chip
            *ngIf="a.faulty"
            label="Guasto"></p-chip>
        </td>

        <td>
          <i
            class="pi pi-pencil text-xs teal-text"
            [pTooltip]="a.notes || 'Nessuna nota'"
            tooltipPosition="top"></i>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td
          colspan="10"
          class="text-center py-2">
          Nessun risultato.
        </td>
      </tr>
    </ng-template>
  </p-table>

  <div class="modal-footer mt-3">
    <div class="flex justify-content-center gap-4">
      <p-button
        (onClick)="close()"
        styleClass="butt w-full red"
        [rounded]="true"
        ><span>Annulla</span>
      </p-button>
      <p-button
        (onClick)="save()"
        styleClass="butt w-full"
        [rounded]="true"
        [disabled]="!selectedAM.value"
        ><span>Conferma</span>
      </p-button>
    </div>
  </div>
</div>

<ng-template
  #none
  class="text-center"
  >-</ng-template
>
